<canvas #chartElement [width]="dimensions.width + 'px'" [height]="dimensions.height + 'px'"></canvas>
